// Settings page tabs, in order; ?tab=<key> opens one.
const ALL_TABS = [
  { key: 'account' },
  { key: 'connections' },
  { key: 'play' },
  { key: 'audio' },
  { key: 'notifications' },
  { key: 'billing' },
];

// Audio only holds matchmaking sounds so far, so it shares matchmaking's gate.
export function visibleTabs(user) {
  return ALL_TABS.filter(({ key }) => key !== 'audio' || !!user?.can_use_matchmaking);
}

export function tabFromQuery(tab, user) {
  return visibleTabs(user).some(({ key }) => key === tab) ? tab : 'account';
}
